var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.615 9.32987C31.1274 8.09793 32.8725 8.09793 33.3849 9.32987L39.0542 22.9604C39.2702 23.4798 39.7586 23.8346 40.3193 23.8796L55.0346 25.0593C56.3646 25.1659 56.9039 26.8257 55.8906 27.6937L44.6791 37.2976C44.2519 37.6635 44.0653 38.2376 44.1958 38.7848L47.6211 53.1444C47.9307 54.4423 46.5188 55.4681 45.3802 54.7726L32.7818 47.0775C32.3018 46.7844 31.6981 46.7844 31.2181 47.0775L18.6197 54.7726C17.481 55.4681 16.0692 54.4423 16.3787 53.1444L19.8041 38.7848C19.9346 38.2376 19.748 37.6635 19.3208 37.2976L8.1093 27.6937C7.09599 26.8257 7.63528 25.1659 8.96526 25.0593L23.6806 23.8796C24.2413 23.8346 24.7297 23.4798 24.9457 22.9604L30.615 9.32987Z",
    fill: "#F2B249",
    stroke: "#F2B249",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.01aba6e01b554f05b72a334ca960adce.svg";
export { ForwardRef as ReactComponent };